import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';

import InlineVideo from 'components/InlineVideo/InlineVideo';
import { ResponsiveImage } from 'sheets';
import { optionalAttribute } from 'utils/jsx';

const stylesMap = {
  right: require(`./ValuePropImageRight.css`),
  left: require(`./ValuePropImageLeft.css`),
  bottom: require(`./ValuePropImageBottom.css`),
};

let styles;

class ValueProp extends React.Component {
  constructor(props) {
    super(props);
    styles = stylesMap[props.imagePosition];
  }

  componentWillUpdate() {
    styles = stylesMap[this.props.imagePosition];
  }

  createMarkup(content) {
    return {__html: content };
  }

  renderMedia() {
    if (this.props.imageConfig) {
      return (
        <ResponsiveImage
          config={this.props.imageConfig}
          description={this.props.t.imageDescription}
        />
      );
    } else if (this.props.videoConfig) {
      return (
        <InlineVideo
          imageDescription={this.props.t.imageDescription}
          videoConfig={this.props.videoConfig}
        />
      );
    }

    return null;
  }

  render() {
    const containerClass = classNames(styles[`container`], {
      [this.props.containerStyles]: this.props.containerStyles,
    });
    const contentClass = classNames(styles[`content`], {
      [this.props.contentStyles]: this.props.contentStyles,
    });
    const imageContainerClass = classNames(styles[`image-container`], {
      [this.props.imageContainerStyles]: this.props.imageContainerStyles,
    });
    const bodyClass = classNames(styles[`body`], {
      [this.props.bodyStyles]: this.props.bodyStyles,
    });
    const imageClass = optionalAttribute(`className`, this.props.imageStyles, this.props.imageStyles);

    return (
      <section className={containerClass}>
        <div className={styles[`content-container`]}>
          <div className={styles[`content-inner`]}>
            <div className={contentClass}>
              <h2 className={styles[`heading`]}>{this.props.t.heading}</h2>
              <p
                className={bodyClass}
                dangerouslySetInnerHTML={this.createMarkup(this.props.t.content)}
              />
              {this.props.children}
            </div>
          </div>
        </div>
        <div className={imageContainerClass}>
          <div
            role="presentation"
            {...imageClass}
          >
            {this.renderMedia()}
          </div>
        </div>
      </section>
    );
  }
}

ValueProp.propTypes = {
  bodyStyles: PropTypes.string,
  containerStyles: PropTypes.string,
  contentStyles: PropTypes.string,
  imageConfig: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]),
  imageContainerStyles: PropTypes.string,
  imagePosition: PropTypes.oneOf([ `right`, `left`, `bottom` ]),
  imageStyles: PropTypes.string,
  t: PropTypes.shape({
    content: PropTypes.string.isRequired,
    heading: PropTypes.string.isRequired,
    imageDescription: PropTypes.string.isRequired,
  }).isRequired,
  videoConfig: PropTypes.shape({
    path: PropTypes.string.isRequired,
    height: PropTypes.string,
    width: PropTypes.string,
    fallback: PropTypes.string.isRequired,
  }),
};

export default ValueProp;
